const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-single-image'] = {
        c: () => require('partner/modules/moe-single-image/moe-single-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-single-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-single-image'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-single-image|moe-single-image'] = {
                c: () => require('partner/modules/moe-single-image/moe-single-image.view.tsx'),
                cn: '__local__-__local__-moe-single-image'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };